import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type ConnectionMeta = {
  __typename?: 'ConnectionMeta';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
};

export enum DomainNameApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type DomainNameMailFromConfiguration = {
  __typename?: 'DomainNameMailFromConfiguration';
  domain: Scalars['String']['output'];
  records: Array<DomainNameVerificationDnsRecord>;
  status: Scalars['String']['output'];
  subdomain: Scalars['String']['output'];
};

export type DomainNameVerification = {
  __typename?: 'DomainNameVerification';
  approvalStatus: DomainNameApprovalStatus;
  createdAt: Scalars['Date']['output'];
  domainName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mailFromConfiguration?: Maybe<DomainNameMailFromConfiguration>;
  platformId: Scalars['ID']['output'];
  status: DomainNameVerificationStatus;
  updatedAt: Scalars['Date']['output'];
  verificationDnsRecords: Array<DomainNameVerificationDnsRecord>;
};

export type DomainNameVerificationConnection = {
  __typename?: 'DomainNameVerificationConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<DomainNameVerification>;
};

export type DomainNameVerificationDnsRecord = {
  __typename?: 'DomainNameVerificationDnsRecord';
  isPresent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum DomainNameVerificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type EmailMessage = {
  __typename?: 'EmailMessage';
  createdAt: Scalars['Date']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: WaypointMessage;
  platformId: Scalars['ID']['output'];
  processedAt?: Maybe<Scalars['Date']['output']>;
  source: Scalars['String']['output'];
  sourceEmailMessagesBatchId?: Maybe<Scalars['ID']['output']>;
  sourceWorkflowRunId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  waypointTemplateId?: Maybe<Scalars['ID']['output']>;
};

export type EmailMessageConnection = {
  __typename?: 'EmailMessageConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<EmailMessage>;
};

export type EmailMessagesFilterInput = {
  environment?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  refreshDomainNameVerificationApproval: DomainNameVerification;
  sendDomainNameVerificationApprovedEmailMessage: DomainNameVerification;
  sendDoubledDomainNameVerificationEmailMessage: DomainNameVerification;
  triggerEmailMessageFail: EmailMessage;
  triggerEmailMessageSend: EmailMessage;
  triggerWorkflowEventFail: WorkflowEvent;
  triggerWorkflowEventProcess: WorkflowEvent;
  updateDomainNameVerificationApproval: DomainNameVerification;
  updateDomainNameVerificationMailFrom: DomainNameVerification;
  updatePlatform: Platform;
};


export type MutationRefreshDomainNameVerificationApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendDomainNameVerificationApprovedEmailMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendDoubledDomainNameVerificationEmailMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggerEmailMessageFailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggerEmailMessageSendArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggerWorkflowEventFailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTriggerWorkflowEventProcessArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateDomainNameVerificationApprovalArgs = {
  approvalStatus: DomainNameApprovalStatus;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDomainNameVerificationMailFromArgs = {
  id: Scalars['ID']['input'];
  subdomain: Scalars['String']['input'];
};


export type MutationUpdatePlatformArgs = {
  data: UpdatePlatformData;
  id: Scalars['ID']['input'];
};

export type Platform = {
  __typename?: 'Platform';
  activeWaypointTier: Scalars['String']['output'];
  apiKeysCount: Scalars['Int']['output'];
  billingEmailAddress?: Maybe<Scalars['String']['output']>;
  contactsCount: Scalars['Int']['output'];
  contactsGroupContactsCount: Scalars['Int']['output'];
  contactsGroupCount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  domainNameVerificationsCount: Scalars['Int']['output'];
  emailMessagesBatchesCount: Scalars['Int']['output'];
  emailMessagesCount: Scalars['Int']['output'];
  featureLegacyTemplatesEnabled: Scalars['Boolean']['output'];
  featureRawTemplatePreviewEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  platformUsersCount: Scalars['Int']['output'];
  requestLogsCount: Scalars['Int']['output'];
  sendingStatus: PlatformSendingStatus;
  sesConfiguration: PlatformSesConfiguration;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionStatus: Scalars['String']['output'];
  templateImagesCount: Scalars['Int']['output'];
  templatesCount: Scalars['Int']['output'];
  timelineLogItemsCount: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  verifiedEmailAddressesCount: Scalars['Int']['output'];
  waypointSendingStrategy: PlatformWaypointSendingStrategy;
  workflowRunCommandsCount: Scalars['Int']['output'];
  workflowRunsCount: Scalars['Int']['output'];
  workflowsCount: Scalars['Int']['output'];
};

export type PlatformConnection = {
  __typename?: 'PlatformConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<Platform>;
};

export enum PlatformSendingStatus {
  ApprovalNeeded = 'APPROVAL_NEEDED',
  Disabled = 'DISABLED',
  Halted = 'HALTED',
  LiveMode = 'LIVE_MODE',
  Sample = 'SAMPLE',
  SubscriptionNeeded = 'SUBSCRIPTION_NEEDED',
  TestMode = 'TEST_MODE',
  VerificationNeeded = 'VERIFICATION_NEEDED'
}

export type PlatformSesConfiguration = {
  __typename?: 'PlatformSesConfiguration';
  clickEvent?: Maybe<Scalars['Boolean']['output']>;
  ipPoolName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openEvent?: Maybe<Scalars['Boolean']['output']>;
};

export enum PlatformWaypointSendingStrategy {
  Disabled = 'DISABLED',
  HaltedHighRisk = 'HALTED_HIGH_RISK',
  HaltedHighVolume = 'HALTED_HIGH_VOLUME',
  HaltedStandard = 'HALTED_STANDARD',
  HighRisk = 'HIGH_RISK',
  HighVolume = 'HIGH_VOLUME',
  Paused = 'PAUSED',
  Sample = 'SAMPLE',
  Standard = 'STANDARD'
}

export type Query = {
  __typename?: 'Query';
  DomainNameVerification: DomainNameVerification;
  DomainNameVerifications: DomainNameVerificationConnection;
  EmailMessages: EmailMessageConnection;
  Platform: Platform;
  PlatformDomainNameVerifications: DomainNameVerificationConnection;
  PlatformVerifiedEmailAddresses: VerifiedEmailAddressConnection;
  Platforms: PlatformConnection;
  SystemConfiguration?: Maybe<SystemConfiguration>;
  Users: UserConnection;
};


export type QueryDomainNameVerificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDomainNameVerificationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailMessagesArgs = {
  filter?: InputMaybe<EmailMessagesFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformDomainNameVerificationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  platformId: Scalars['ID']['input'];
};


export type QueryPlatformVerifiedEmailAddressesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  platformId: Scalars['ID']['input'];
};


export type QueryPlatformsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type SystemConfiguration = {
  __typename?: 'SystemConfiguration';
  availableSesIpPools: Array<Scalars['String']['output']>;
};

export type UpdatePlatformData = {
  featureLegacyTemplatesEnabled: Scalars['Boolean']['input'];
  featureRawTemplatePreviewEnabled: Scalars['Boolean']['input'];
  ipPoolName?: InputMaybe<Scalars['String']['input']>;
  waypointSendingStrategy: PlatformWaypointSendingStrategy;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['Date']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['Date']['output'];
  platformIds: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type UserConnection = {
  __typename?: 'UserConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<User>;
};

export type VerifiedEmailAddress = {
  __typename?: 'VerifiedEmailAddress';
  createdAt: Scalars['Date']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: VerifiedEmailAddressStatus;
  updatedAt: Scalars['Date']['output'];
  value: Scalars['String']['output'];
};

export type VerifiedEmailAddressConnection = {
  __typename?: 'VerifiedEmailAddressConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<VerifiedEmailAddress>;
};

export enum VerifiedEmailAddressStatus {
  Archived = 'ARCHIVED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type WaypointMessage = {
  __typename?: 'WaypointMessage';
  bcc?: Maybe<Scalars['String']['output']>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  preheader?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type WorkflowEvent = {
  __typename?: 'WorkflowEvent';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  metaId?: Maybe<Scalars['ID']['output']>;
  source: WorkflowEventSource;
  status: WorkflowEventStatus;
  updatedAt: Scalars['Date']['output'];
  workflowId?: Maybe<Scalars['ID']['output']>;
  workflowKey?: Maybe<Scalars['String']['output']>;
};

export type WorkflowEventConnection = {
  __typename?: 'WorkflowEventConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<WorkflowEvent>;
};

export enum WorkflowEventSource {
  Api = 'API',
  Preview = 'PREVIEW',
  SandboxApi = 'SANDBOX_API',
  Trigger = 'TRIGGER'
}

export enum WorkflowEventStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export type FDomainNameVerificationFragment = { __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string };

export type FDomainNameVerificationRecordsFragment = { __typename?: 'DomainNameVerification', verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, value: string, type: string, isPresent: boolean }>, mailFromConfiguration?: { __typename?: 'DomainNameMailFromConfiguration', subdomain: string, domain: string, status: string, records: Array<{ __typename?: 'DomainNameVerificationDnsRecord', type: string, name: string, value: string, isPresent: boolean }> } | null };

export type FEmailMessageFragment = { __typename?: 'EmailMessage', id: string, createdAt: any, updatedAt: any, status: string, source: string, processedAt?: any | null, platformId: string, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, errorMessage?: string | null, message: { __typename?: 'WaypointMessage', to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, from?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null } };

export type FPlatformFragment = { __typename?: 'Platform', id: string, createdAt: any, deletedAt?: any | null, name: string, stripeCustomerId?: string | null, billingEmailAddress?: string | null, activeWaypointTier: string, waypointSendingStrategy: PlatformWaypointSendingStrategy, featureRawTemplatePreviewEnabled: boolean, featureLegacyTemplatesEnabled: boolean, stripeSubscriptionStatus: string };

export type FPlatformQueriesFragment = { __typename?: 'Platform', emailMessagesCount: number, workflowRunsCount: number, sendingStatus: PlatformSendingStatus };

export type FPlatformSesConfigurationFragment = { __typename?: 'Platform', id: string, sesConfiguration: { __typename?: 'PlatformSesConfiguration', name?: string | null, ipPoolName?: string | null, clickEvent?: boolean | null, openEvent?: boolean | null } };

export type FPlatformAllCountsFragment = { __typename?: 'Platform', apiKeysCount: number, contactsCount: number, contactsGroupContactsCount: number, contactsGroupCount: number, domainNameVerificationsCount: number, emailMessagesBatchesCount: number, emailMessagesCount: number, requestLogsCount: number, platformUsersCount: number, templateImagesCount: number, templatesCount: number, timelineLogItemsCount: number, verifiedEmailAddressesCount: number, workflowRunCommandsCount: number, workflowRunsCount: number, workflowsCount: number };

export type FUserFragment = { __typename?: 'User', id: string, createdAt: any, emailAddress: string, lastSeenAt: any, platformIds: Array<string> };

export type FVerifiedEmailAddressFragment = { __typename?: 'VerifiedEmailAddress', id: string, createdAt: any, value: string };

export type FWorkflowEventFragment = { __typename?: 'WorkflowEvent', id: string, createdAt: any, updatedAt: any, status: WorkflowEventStatus, source: WorkflowEventSource };

export type RefreshDomainNameVerificationApprovalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RefreshDomainNameVerificationApprovalMutation = { __typename?: 'Mutation', refreshDomainNameVerificationApproval: { __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string } };

export type SendDomainNameVerificationApprovedEmailMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendDomainNameVerificationApprovedEmailMessageMutation = { __typename?: 'Mutation', sendDomainNameVerificationApprovedEmailMessage: { __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string } };

export type SendDoubledDomainNameVerificationEmailMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendDoubledDomainNameVerificationEmailMessageMutation = { __typename?: 'Mutation', sendDoubledDomainNameVerificationEmailMessage: { __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string } };

export type TriggerEmailMessageFailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggerEmailMessageFailMutation = { __typename?: 'Mutation', triggerEmailMessageFail: { __typename?: 'EmailMessage', id: string, createdAt: any, updatedAt: any, status: string, source: string, processedAt?: any | null, platformId: string, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, errorMessage?: string | null, message: { __typename?: 'WaypointMessage', to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, from?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null } } };

export type TriggerEmailMessageSendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggerEmailMessageSendMutation = { __typename?: 'Mutation', triggerEmailMessageSend: { __typename?: 'EmailMessage', id: string, createdAt: any, updatedAt: any, status: string, source: string, processedAt?: any | null, platformId: string, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, errorMessage?: string | null, message: { __typename?: 'WaypointMessage', to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, from?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null } } };

export type TriggerWorkflowEventFailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggerWorkflowEventFailMutation = { __typename?: 'Mutation', triggerWorkflowEventFail: { __typename?: 'WorkflowEvent', id: string, createdAt: any, updatedAt: any, status: WorkflowEventStatus, source: WorkflowEventSource } };

export type TriggerWorkflowEventProcessMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TriggerWorkflowEventProcessMutation = { __typename?: 'Mutation', triggerWorkflowEventProcess: { __typename?: 'WorkflowEvent', id: string, createdAt: any, updatedAt: any, status: WorkflowEventStatus, source: WorkflowEventSource } };

export type UpdateDomainNameVerificationApprovalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  approvalStatus: DomainNameApprovalStatus;
}>;


export type UpdateDomainNameVerificationApprovalMutation = { __typename?: 'Mutation', updateDomainNameVerificationApproval: { __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string } };

export type UpdateDomainNameVerificationMailFromMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  subdomain: Scalars['String']['input'];
}>;


export type UpdateDomainNameVerificationMailFromMutation = { __typename?: 'Mutation', updateDomainNameVerificationMailFrom: { __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string, verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, value: string, type: string, isPresent: boolean }>, mailFromConfiguration?: { __typename?: 'DomainNameMailFromConfiguration', subdomain: string, domain: string, status: string, records: Array<{ __typename?: 'DomainNameVerificationDnsRecord', type: string, name: string, value: string, isPresent: boolean }> } | null } };

export type UpdatePlatformMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdatePlatformData;
}>;


export type UpdatePlatformMutation = { __typename?: 'Mutation', updatePlatform: { __typename?: 'Platform', id: string, createdAt: any, deletedAt?: any | null, name: string, stripeCustomerId?: string | null, billingEmailAddress?: string | null, activeWaypointTier: string, waypointSendingStrategy: PlatformWaypointSendingStrategy, featureRawTemplatePreviewEnabled: boolean, featureLegacyTemplatesEnabled: boolean, stripeSubscriptionStatus: string } };

export type DomainNameVerificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DomainNameVerificationQuery = { __typename?: 'Query', DomainNameVerification: { __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string, verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, value: string, type: string, isPresent: boolean }>, mailFromConfiguration?: { __typename?: 'DomainNameMailFromConfiguration', subdomain: string, domain: string, status: string, records: Array<{ __typename?: 'DomainNameVerificationDnsRecord', type: string, name: string, value: string, isPresent: boolean }> } | null } };

export type DomainNameVerificationsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
}>;


export type DomainNameVerificationsQuery = { __typename?: 'Query', DomainNameVerifications: { __typename?: 'DomainNameVerificationConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string }> } };

export type EmailMessagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EmailMessagesFilterInput>;
}>;


export type EmailMessagesQuery = { __typename?: 'Query', EmailMessages: { __typename?: 'EmailMessageConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'EmailMessage', id: string, createdAt: any, updatedAt: any, status: string, source: string, processedAt?: any | null, platformId: string, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, errorMessage?: string | null, message: { __typename?: 'WaypointMessage', to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, from?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null } }> } };

export type PlatformQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformQuery = { __typename?: 'Query', Platform: { __typename?: 'Platform', id: string, createdAt: any, deletedAt?: any | null, name: string, stripeCustomerId?: string | null, billingEmailAddress?: string | null, activeWaypointTier: string, waypointSendingStrategy: PlatformWaypointSendingStrategy, featureRawTemplatePreviewEnabled: boolean, featureLegacyTemplatesEnabled: boolean, stripeSubscriptionStatus: string, emailMessagesCount: number, workflowRunsCount: number, sendingStatus: PlatformSendingStatus } };

export type LightPlatformQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LightPlatformQuery = { __typename?: 'Query', Platform: { __typename?: 'Platform', id: string, createdAt: any, deletedAt?: any | null, name: string, stripeCustomerId?: string | null, billingEmailAddress?: string | null, activeWaypointTier: string, waypointSendingStrategy: PlatformWaypointSendingStrategy, featureRawTemplatePreviewEnabled: boolean, featureLegacyTemplatesEnabled: boolean, stripeSubscriptionStatus: string } };

export type PlatformCountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformCountsQuery = { __typename?: 'Query', Platform: { __typename?: 'Platform', id: string, apiKeysCount: number, contactsCount: number, contactsGroupContactsCount: number, contactsGroupCount: number, domainNameVerificationsCount: number, emailMessagesBatchesCount: number, emailMessagesCount: number, requestLogsCount: number, platformUsersCount: number, templateImagesCount: number, templatesCount: number, timelineLogItemsCount: number, verifiedEmailAddressesCount: number, workflowRunCommandsCount: number, workflowRunsCount: number, workflowsCount: number, sesConfiguration: { __typename?: 'PlatformSesConfiguration', name?: string | null, ipPoolName?: string | null, clickEvent?: boolean | null, openEvent?: boolean | null } } };

export type PlatformDomainNameVerificationsQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
}>;


export type PlatformDomainNameVerificationsQuery = { __typename?: 'Query', PlatformDomainNameVerifications: { __typename?: 'DomainNameVerificationConnection', count: number, nodes: Array<{ __typename?: 'DomainNameVerification', id: string, createdAt: any, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, platformId: string }> } };

export type PlatformVerifiedEmailAddressesQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
}>;


export type PlatformVerifiedEmailAddressesQuery = { __typename?: 'Query', PlatformVerifiedEmailAddresses: { __typename?: 'VerifiedEmailAddressConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'VerifiedEmailAddress', id: string, createdAt: any, value: string }> } };

export type PlatformsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  tier?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlatformsQuery = { __typename?: 'Query', Platforms: { __typename?: 'PlatformConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'Platform', id: string, createdAt: any, deletedAt?: any | null, name: string, stripeCustomerId?: string | null, billingEmailAddress?: string | null, activeWaypointTier: string, waypointSendingStrategy: PlatformWaypointSendingStrategy, featureRawTemplatePreviewEnabled: boolean, featureLegacyTemplatesEnabled: boolean, stripeSubscriptionStatus: string }> } };

export type SystemConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemConfigurationQuery = { __typename?: 'Query', SystemConfiguration?: { __typename?: 'SystemConfiguration', availableSesIpPools: Array<string> } | null };

export type UsersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
}>;


export type UsersQuery = { __typename?: 'Query', Users: { __typename?: 'UserConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'User', id: string, createdAt: any, emailAddress: string, lastSeenAt: any, platformIds: Array<string> }> } };

export const FDomainNameVerificationFragmentDoc = gql`
    fragment FDomainNameVerification on DomainNameVerification {
  id
  createdAt
  domainName
  status
  approvalStatus
  platformId
}
    `;
export const FDomainNameVerificationRecordsFragmentDoc = gql`
    fragment FDomainNameVerificationRecords on DomainNameVerification {
  verificationDnsRecords {
    name
    value
    type
    isPresent
  }
  mailFromConfiguration {
    subdomain
    domain
    status
    records {
      type
      name
      value
      isPresent
    }
  }
}
    `;
export const FEmailMessageFragmentDoc = gql`
    fragment FEmailMessage on EmailMessage {
  id
  createdAt
  updatedAt
  status
  source
  processedAt
  platformId
  waypointTemplateId
  sourceWorkflowRunId
  errorMessage
  message {
    to
    cc
    bcc
    replyTo
    from
    subject
    bodyHtml
    bodyText
    preheader
  }
}
    `;
export const FPlatformFragmentDoc = gql`
    fragment FPlatform on Platform {
  id
  createdAt
  deletedAt
  name
  stripeCustomerId
  billingEmailAddress
  activeWaypointTier
  waypointSendingStrategy
  featureRawTemplatePreviewEnabled
  featureLegacyTemplatesEnabled
  stripeSubscriptionStatus
}
    `;
export const FPlatformQueriesFragmentDoc = gql`
    fragment FPlatformQueries on Platform {
  emailMessagesCount
  workflowRunsCount
  sendingStatus
}
    `;
export const FPlatformSesConfigurationFragmentDoc = gql`
    fragment FPlatformSesConfiguration on Platform {
  id
  sesConfiguration {
    name
    ipPoolName
    clickEvent
    openEvent
  }
}
    `;
export const FPlatformAllCountsFragmentDoc = gql`
    fragment FPlatformAllCounts on Platform {
  apiKeysCount
  contactsCount
  contactsGroupContactsCount
  contactsGroupCount
  domainNameVerificationsCount
  emailMessagesBatchesCount
  emailMessagesCount
  requestLogsCount
  platformUsersCount
  templateImagesCount
  templatesCount
  timelineLogItemsCount
  verifiedEmailAddressesCount
  workflowRunCommandsCount
  workflowRunsCount
  workflowsCount
}
    `;
export const FUserFragmentDoc = gql`
    fragment FUser on User {
  id
  createdAt
  emailAddress
  lastSeenAt
  platformIds
}
    `;
export const FVerifiedEmailAddressFragmentDoc = gql`
    fragment FVerifiedEmailAddress on VerifiedEmailAddress {
  id
  createdAt
  value
}
    `;
export const FWorkflowEventFragmentDoc = gql`
    fragment FWorkflowEvent on WorkflowEvent {
  id
  createdAt
  updatedAt
  status
  source
}
    `;
export const RefreshDomainNameVerificationApprovalDocument = gql`
    mutation RefreshDomainNameVerificationApproval($id: ID!) {
  refreshDomainNameVerificationApproval(id: $id) {
    ...FDomainNameVerification
  }
}
    ${FDomainNameVerificationFragmentDoc}`;
export type RefreshDomainNameVerificationApprovalMutationFn = Apollo.MutationFunction<RefreshDomainNameVerificationApprovalMutation, RefreshDomainNameVerificationApprovalMutationVariables>;

/**
 * __useRefreshDomainNameVerificationApprovalMutation_raw__
 *
 * To run a mutation, you first call `useRefreshDomainNameVerificationApprovalMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDomainNameVerificationApprovalMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDomainNameVerificationApprovalMutationRaw, { data, loading, error }] = useRefreshDomainNameVerificationApprovalMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshDomainNameVerificationApprovalMutation_raw(baseOptions?: Apollo.MutationHookOptions<RefreshDomainNameVerificationApprovalMutation, RefreshDomainNameVerificationApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshDomainNameVerificationApprovalMutation, RefreshDomainNameVerificationApprovalMutationVariables>(RefreshDomainNameVerificationApprovalDocument, options);
      }
export type RefreshDomainNameVerificationApprovalMutation_rawHookResult = ReturnType<typeof useRefreshDomainNameVerificationApprovalMutation_raw>;
export type RefreshDomainNameVerificationApprovalMutationResult = Apollo.MutationResult<RefreshDomainNameVerificationApprovalMutation>;
export type RefreshDomainNameVerificationApprovalMutationOptions = Apollo.BaseMutationOptions<RefreshDomainNameVerificationApprovalMutation, RefreshDomainNameVerificationApprovalMutationVariables>;
export const SendDomainNameVerificationApprovedEmailMessageDocument = gql`
    mutation SendDomainNameVerificationApprovedEmailMessage($id: ID!) {
  sendDomainNameVerificationApprovedEmailMessage(id: $id) {
    ...FDomainNameVerification
  }
}
    ${FDomainNameVerificationFragmentDoc}`;
export type SendDomainNameVerificationApprovedEmailMessageMutationFn = Apollo.MutationFunction<SendDomainNameVerificationApprovedEmailMessageMutation, SendDomainNameVerificationApprovedEmailMessageMutationVariables>;

/**
 * __useSendDomainNameVerificationApprovedEmailMessageMutation_raw__
 *
 * To run a mutation, you first call `useSendDomainNameVerificationApprovedEmailMessageMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDomainNameVerificationApprovedEmailMessageMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDomainNameVerificationApprovedEmailMessageMutationRaw, { data, loading, error }] = useSendDomainNameVerificationApprovedEmailMessageMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendDomainNameVerificationApprovedEmailMessageMutation_raw(baseOptions?: Apollo.MutationHookOptions<SendDomainNameVerificationApprovedEmailMessageMutation, SendDomainNameVerificationApprovedEmailMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDomainNameVerificationApprovedEmailMessageMutation, SendDomainNameVerificationApprovedEmailMessageMutationVariables>(SendDomainNameVerificationApprovedEmailMessageDocument, options);
      }
export type SendDomainNameVerificationApprovedEmailMessageMutation_rawHookResult = ReturnType<typeof useSendDomainNameVerificationApprovedEmailMessageMutation_raw>;
export type SendDomainNameVerificationApprovedEmailMessageMutationResult = Apollo.MutationResult<SendDomainNameVerificationApprovedEmailMessageMutation>;
export type SendDomainNameVerificationApprovedEmailMessageMutationOptions = Apollo.BaseMutationOptions<SendDomainNameVerificationApprovedEmailMessageMutation, SendDomainNameVerificationApprovedEmailMessageMutationVariables>;
export const SendDoubledDomainNameVerificationEmailMessageDocument = gql`
    mutation SendDoubledDomainNameVerificationEmailMessage($id: ID!) {
  sendDoubledDomainNameVerificationEmailMessage(id: $id) {
    ...FDomainNameVerification
  }
}
    ${FDomainNameVerificationFragmentDoc}`;
export type SendDoubledDomainNameVerificationEmailMessageMutationFn = Apollo.MutationFunction<SendDoubledDomainNameVerificationEmailMessageMutation, SendDoubledDomainNameVerificationEmailMessageMutationVariables>;

/**
 * __useSendDoubledDomainNameVerificationEmailMessageMutation_raw__
 *
 * To run a mutation, you first call `useSendDoubledDomainNameVerificationEmailMessageMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDoubledDomainNameVerificationEmailMessageMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDoubledDomainNameVerificationEmailMessageMutationRaw, { data, loading, error }] = useSendDoubledDomainNameVerificationEmailMessageMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendDoubledDomainNameVerificationEmailMessageMutation_raw(baseOptions?: Apollo.MutationHookOptions<SendDoubledDomainNameVerificationEmailMessageMutation, SendDoubledDomainNameVerificationEmailMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDoubledDomainNameVerificationEmailMessageMutation, SendDoubledDomainNameVerificationEmailMessageMutationVariables>(SendDoubledDomainNameVerificationEmailMessageDocument, options);
      }
export type SendDoubledDomainNameVerificationEmailMessageMutation_rawHookResult = ReturnType<typeof useSendDoubledDomainNameVerificationEmailMessageMutation_raw>;
export type SendDoubledDomainNameVerificationEmailMessageMutationResult = Apollo.MutationResult<SendDoubledDomainNameVerificationEmailMessageMutation>;
export type SendDoubledDomainNameVerificationEmailMessageMutationOptions = Apollo.BaseMutationOptions<SendDoubledDomainNameVerificationEmailMessageMutation, SendDoubledDomainNameVerificationEmailMessageMutationVariables>;
export const TriggerEmailMessageFailDocument = gql`
    mutation TriggerEmailMessageFail($id: ID!) {
  triggerEmailMessageFail(id: $id) {
    ...FEmailMessage
  }
}
    ${FEmailMessageFragmentDoc}`;
export type TriggerEmailMessageFailMutationFn = Apollo.MutationFunction<TriggerEmailMessageFailMutation, TriggerEmailMessageFailMutationVariables>;

/**
 * __useTriggerEmailMessageFailMutation_raw__
 *
 * To run a mutation, you first call `useTriggerEmailMessageFailMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerEmailMessageFailMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerEmailMessageFailMutationRaw, { data, loading, error }] = useTriggerEmailMessageFailMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerEmailMessageFailMutation_raw(baseOptions?: Apollo.MutationHookOptions<TriggerEmailMessageFailMutation, TriggerEmailMessageFailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerEmailMessageFailMutation, TriggerEmailMessageFailMutationVariables>(TriggerEmailMessageFailDocument, options);
      }
export type TriggerEmailMessageFailMutation_rawHookResult = ReturnType<typeof useTriggerEmailMessageFailMutation_raw>;
export type TriggerEmailMessageFailMutationResult = Apollo.MutationResult<TriggerEmailMessageFailMutation>;
export type TriggerEmailMessageFailMutationOptions = Apollo.BaseMutationOptions<TriggerEmailMessageFailMutation, TriggerEmailMessageFailMutationVariables>;
export const TriggerEmailMessageSendDocument = gql`
    mutation TriggerEmailMessageSend($id: ID!) {
  triggerEmailMessageSend(id: $id) {
    ...FEmailMessage
  }
}
    ${FEmailMessageFragmentDoc}`;
export type TriggerEmailMessageSendMutationFn = Apollo.MutationFunction<TriggerEmailMessageSendMutation, TriggerEmailMessageSendMutationVariables>;

/**
 * __useTriggerEmailMessageSendMutation_raw__
 *
 * To run a mutation, you first call `useTriggerEmailMessageSendMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerEmailMessageSendMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerEmailMessageSendMutationRaw, { data, loading, error }] = useTriggerEmailMessageSendMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerEmailMessageSendMutation_raw(baseOptions?: Apollo.MutationHookOptions<TriggerEmailMessageSendMutation, TriggerEmailMessageSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerEmailMessageSendMutation, TriggerEmailMessageSendMutationVariables>(TriggerEmailMessageSendDocument, options);
      }
export type TriggerEmailMessageSendMutation_rawHookResult = ReturnType<typeof useTriggerEmailMessageSendMutation_raw>;
export type TriggerEmailMessageSendMutationResult = Apollo.MutationResult<TriggerEmailMessageSendMutation>;
export type TriggerEmailMessageSendMutationOptions = Apollo.BaseMutationOptions<TriggerEmailMessageSendMutation, TriggerEmailMessageSendMutationVariables>;
export const TriggerWorkflowEventFailDocument = gql`
    mutation TriggerWorkflowEventFail($id: ID!) {
  triggerWorkflowEventFail(id: $id) {
    ...FWorkflowEvent
  }
}
    ${FWorkflowEventFragmentDoc}`;
export type TriggerWorkflowEventFailMutationFn = Apollo.MutationFunction<TriggerWorkflowEventFailMutation, TriggerWorkflowEventFailMutationVariables>;

/**
 * __useTriggerWorkflowEventFailMutation_raw__
 *
 * To run a mutation, you first call `useTriggerWorkflowEventFailMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerWorkflowEventFailMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerWorkflowEventFailMutationRaw, { data, loading, error }] = useTriggerWorkflowEventFailMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerWorkflowEventFailMutation_raw(baseOptions?: Apollo.MutationHookOptions<TriggerWorkflowEventFailMutation, TriggerWorkflowEventFailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerWorkflowEventFailMutation, TriggerWorkflowEventFailMutationVariables>(TriggerWorkflowEventFailDocument, options);
      }
export type TriggerWorkflowEventFailMutation_rawHookResult = ReturnType<typeof useTriggerWorkflowEventFailMutation_raw>;
export type TriggerWorkflowEventFailMutationResult = Apollo.MutationResult<TriggerWorkflowEventFailMutation>;
export type TriggerWorkflowEventFailMutationOptions = Apollo.BaseMutationOptions<TriggerWorkflowEventFailMutation, TriggerWorkflowEventFailMutationVariables>;
export const TriggerWorkflowEventProcessDocument = gql`
    mutation TriggerWorkflowEventProcess($id: ID!) {
  triggerWorkflowEventProcess(id: $id) {
    ...FWorkflowEvent
  }
}
    ${FWorkflowEventFragmentDoc}`;
export type TriggerWorkflowEventProcessMutationFn = Apollo.MutationFunction<TriggerWorkflowEventProcessMutation, TriggerWorkflowEventProcessMutationVariables>;

/**
 * __useTriggerWorkflowEventProcessMutation_raw__
 *
 * To run a mutation, you first call `useTriggerWorkflowEventProcessMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerWorkflowEventProcessMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerWorkflowEventProcessMutationRaw, { data, loading, error }] = useTriggerWorkflowEventProcessMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerWorkflowEventProcessMutation_raw(baseOptions?: Apollo.MutationHookOptions<TriggerWorkflowEventProcessMutation, TriggerWorkflowEventProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerWorkflowEventProcessMutation, TriggerWorkflowEventProcessMutationVariables>(TriggerWorkflowEventProcessDocument, options);
      }
export type TriggerWorkflowEventProcessMutation_rawHookResult = ReturnType<typeof useTriggerWorkflowEventProcessMutation_raw>;
export type TriggerWorkflowEventProcessMutationResult = Apollo.MutationResult<TriggerWorkflowEventProcessMutation>;
export type TriggerWorkflowEventProcessMutationOptions = Apollo.BaseMutationOptions<TriggerWorkflowEventProcessMutation, TriggerWorkflowEventProcessMutationVariables>;
export const UpdateDomainNameVerificationApprovalDocument = gql`
    mutation UpdateDomainNameVerificationApproval($id: ID!, $approvalStatus: DomainNameApprovalStatus!) {
  updateDomainNameVerificationApproval(id: $id, approvalStatus: $approvalStatus) {
    ...FDomainNameVerification
  }
}
    ${FDomainNameVerificationFragmentDoc}`;
export type UpdateDomainNameVerificationApprovalMutationFn = Apollo.MutationFunction<UpdateDomainNameVerificationApprovalMutation, UpdateDomainNameVerificationApprovalMutationVariables>;

/**
 * __useUpdateDomainNameVerificationApprovalMutation_raw__
 *
 * To run a mutation, you first call `useUpdateDomainNameVerificationApprovalMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainNameVerificationApprovalMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainNameVerificationApprovalMutationRaw, { data, loading, error }] = useUpdateDomainNameVerificationApprovalMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      approvalStatus: // value for 'approvalStatus'
 *   },
 * });
 */
export function useUpdateDomainNameVerificationApprovalMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateDomainNameVerificationApprovalMutation, UpdateDomainNameVerificationApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainNameVerificationApprovalMutation, UpdateDomainNameVerificationApprovalMutationVariables>(UpdateDomainNameVerificationApprovalDocument, options);
      }
export type UpdateDomainNameVerificationApprovalMutation_rawHookResult = ReturnType<typeof useUpdateDomainNameVerificationApprovalMutation_raw>;
export type UpdateDomainNameVerificationApprovalMutationResult = Apollo.MutationResult<UpdateDomainNameVerificationApprovalMutation>;
export type UpdateDomainNameVerificationApprovalMutationOptions = Apollo.BaseMutationOptions<UpdateDomainNameVerificationApprovalMutation, UpdateDomainNameVerificationApprovalMutationVariables>;
export const UpdateDomainNameVerificationMailFromDocument = gql`
    mutation UpdateDomainNameVerificationMailFrom($id: ID!, $subdomain: String!) {
  updateDomainNameVerificationMailFrom(id: $id, subdomain: $subdomain) {
    ...FDomainNameVerification
    ...FDomainNameVerificationRecords
  }
}
    ${FDomainNameVerificationFragmentDoc}
${FDomainNameVerificationRecordsFragmentDoc}`;
export type UpdateDomainNameVerificationMailFromMutationFn = Apollo.MutationFunction<UpdateDomainNameVerificationMailFromMutation, UpdateDomainNameVerificationMailFromMutationVariables>;

/**
 * __useUpdateDomainNameVerificationMailFromMutation_raw__
 *
 * To run a mutation, you first call `useUpdateDomainNameVerificationMailFromMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDomainNameVerificationMailFromMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDomainNameVerificationMailFromMutationRaw, { data, loading, error }] = useUpdateDomainNameVerificationMailFromMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useUpdateDomainNameVerificationMailFromMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateDomainNameVerificationMailFromMutation, UpdateDomainNameVerificationMailFromMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDomainNameVerificationMailFromMutation, UpdateDomainNameVerificationMailFromMutationVariables>(UpdateDomainNameVerificationMailFromDocument, options);
      }
export type UpdateDomainNameVerificationMailFromMutation_rawHookResult = ReturnType<typeof useUpdateDomainNameVerificationMailFromMutation_raw>;
export type UpdateDomainNameVerificationMailFromMutationResult = Apollo.MutationResult<UpdateDomainNameVerificationMailFromMutation>;
export type UpdateDomainNameVerificationMailFromMutationOptions = Apollo.BaseMutationOptions<UpdateDomainNameVerificationMailFromMutation, UpdateDomainNameVerificationMailFromMutationVariables>;
export const UpdatePlatformDocument = gql`
    mutation UpdatePlatform($id: ID!, $data: UpdatePlatformData!) {
  updatePlatform(id: $id, data: $data) {
    ...FPlatform
  }
}
    ${FPlatformFragmentDoc}`;
export type UpdatePlatformMutationFn = Apollo.MutationFunction<UpdatePlatformMutation, UpdatePlatformMutationVariables>;

/**
 * __useUpdatePlatformMutation_raw__
 *
 * To run a mutation, you first call `useUpdatePlatformMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformMutationRaw, { data, loading, error }] = useUpdatePlatformMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePlatformMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformMutation, UpdatePlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformMutation, UpdatePlatformMutationVariables>(UpdatePlatformDocument, options);
      }
export type UpdatePlatformMutation_rawHookResult = ReturnType<typeof useUpdatePlatformMutation_raw>;
export type UpdatePlatformMutationResult = Apollo.MutationResult<UpdatePlatformMutation>;
export type UpdatePlatformMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformMutation, UpdatePlatformMutationVariables>;
export const DomainNameVerificationDocument = gql`
    query DomainNameVerification($id: ID!) {
  DomainNameVerification(id: $id) {
    ...FDomainNameVerification
    ...FDomainNameVerificationRecords
  }
}
    ${FDomainNameVerificationFragmentDoc}
${FDomainNameVerificationRecordsFragmentDoc}`;

/**
 * __useDomainNameVerificationQuery_raw__
 *
 * To run a query within a React component, call `useDomainNameVerificationQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useDomainNameVerificationQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainNameVerificationQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDomainNameVerificationQuery_raw(baseOptions: Apollo.QueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables> & ({ variables: DomainNameVerificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>(DomainNameVerificationDocument, options);
      }
export function useDomainNameVerificationLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>(DomainNameVerificationDocument, options);
        }
// @ts-ignore
export function useDomainNameVerificationSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>;
export function useDomainNameVerificationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<DomainNameVerificationQuery | undefined, DomainNameVerificationQueryVariables>;
export function useDomainNameVerificationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>(DomainNameVerificationDocument, options);
        }
export type DomainNameVerificationQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationQuery_raw>;
export type DomainNameVerificationLazyQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationLazyQuery_raw>;
export type DomainNameVerificationSuspenseQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationSuspenseQuery_raw>;
export type DomainNameVerificationQueryResult = Apollo.QueryResult<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>;
export const DomainNameVerificationsDocument = gql`
    query DomainNameVerifications($page: Int!) {
  DomainNameVerifications(page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FDomainNameVerification
    }
  }
}
    ${FDomainNameVerificationFragmentDoc}`;

/**
 * __useDomainNameVerificationsQuery_raw__
 *
 * To run a query within a React component, call `useDomainNameVerificationsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useDomainNameVerificationsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainNameVerificationsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDomainNameVerificationsQuery_raw(baseOptions: Apollo.QueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables> & ({ variables: DomainNameVerificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>(DomainNameVerificationsDocument, options);
      }
export function useDomainNameVerificationsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>(DomainNameVerificationsDocument, options);
        }
// @ts-ignore
export function useDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>;
export function useDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<DomainNameVerificationsQuery | undefined, DomainNameVerificationsQueryVariables>;
export function useDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>(DomainNameVerificationsDocument, options);
        }
export type DomainNameVerificationsQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationsQuery_raw>;
export type DomainNameVerificationsLazyQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationsLazyQuery_raw>;
export type DomainNameVerificationsSuspenseQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationsSuspenseQuery_raw>;
export type DomainNameVerificationsQueryResult = Apollo.QueryResult<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>;
export const EmailMessagesDocument = gql`
    query EmailMessages($page: Int, $filter: EmailMessagesFilterInput) {
  EmailMessages(page: $page, filter: $filter) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FEmailMessage
    }
  }
}
    ${FEmailMessageFragmentDoc}`;

/**
 * __useEmailMessagesQuery_raw__
 *
 * To run a query within a React component, call `useEmailMessagesQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useEmailMessagesQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMessagesQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmailMessagesQuery_raw(baseOptions?: Apollo.QueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMessagesQuery, EmailMessagesQueryVariables>(EmailMessagesDocument, options);
      }
export function useEmailMessagesLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMessagesQuery, EmailMessagesQueryVariables>(EmailMessagesDocument, options);
        }
// @ts-ignore
export function useEmailMessagesSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessagesQuery, EmailMessagesQueryVariables>;
export function useEmailMessagesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessagesQuery | undefined, EmailMessagesQueryVariables>;
export function useEmailMessagesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailMessagesQuery, EmailMessagesQueryVariables>(EmailMessagesDocument, options);
        }
export type EmailMessagesQuery_rawHookResult = ReturnType<typeof useEmailMessagesQuery_raw>;
export type EmailMessagesLazyQuery_rawHookResult = ReturnType<typeof useEmailMessagesLazyQuery_raw>;
export type EmailMessagesSuspenseQuery_rawHookResult = ReturnType<typeof useEmailMessagesSuspenseQuery_raw>;
export type EmailMessagesQueryResult = Apollo.QueryResult<EmailMessagesQuery, EmailMessagesQueryVariables>;
export const PlatformDocument = gql`
    query Platform($id: ID!) {
  Platform(id: $id) {
    ...FPlatform
    ...FPlatformQueries
  }
}
    ${FPlatformFragmentDoc}
${FPlatformQueriesFragmentDoc}`;

/**
 * __usePlatformQuery_raw__
 *
 * To run a query within a React component, call `usePlatformQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlatformQuery_raw(baseOptions: Apollo.QueryHookOptions<PlatformQuery, PlatformQueryVariables> & ({ variables: PlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
      }
export function usePlatformLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformQuery, PlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
        }
// @ts-ignore
export function usePlatformSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformQuery, PlatformQueryVariables>;
export function usePlatformSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformQuery | undefined, PlatformQueryVariables>;
export function usePlatformSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
        }
export type PlatformQuery_rawHookResult = ReturnType<typeof usePlatformQuery_raw>;
export type PlatformLazyQuery_rawHookResult = ReturnType<typeof usePlatformLazyQuery_raw>;
export type PlatformSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformSuspenseQuery_raw>;
export type PlatformQueryResult = Apollo.QueryResult<PlatformQuery, PlatformQueryVariables>;
export const LightPlatformDocument = gql`
    query LightPlatform($id: ID!) {
  Platform(id: $id) {
    ...FPlatform
  }
}
    ${FPlatformFragmentDoc}`;

/**
 * __useLightPlatformQuery_raw__
 *
 * To run a query within a React component, call `useLightPlatformQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useLightPlatformQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLightPlatformQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLightPlatformQuery_raw(baseOptions: Apollo.QueryHookOptions<LightPlatformQuery, LightPlatformQueryVariables> & ({ variables: LightPlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LightPlatformQuery, LightPlatformQueryVariables>(LightPlatformDocument, options);
      }
export function useLightPlatformLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<LightPlatformQuery, LightPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LightPlatformQuery, LightPlatformQueryVariables>(LightPlatformDocument, options);
        }
// @ts-ignore
export function useLightPlatformSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<LightPlatformQuery, LightPlatformQueryVariables>): Apollo.UseSuspenseQueryResult<LightPlatformQuery, LightPlatformQueryVariables>;
export function useLightPlatformSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LightPlatformQuery, LightPlatformQueryVariables>): Apollo.UseSuspenseQueryResult<LightPlatformQuery | undefined, LightPlatformQueryVariables>;
export function useLightPlatformSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LightPlatformQuery, LightPlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LightPlatformQuery, LightPlatformQueryVariables>(LightPlatformDocument, options);
        }
export type LightPlatformQuery_rawHookResult = ReturnType<typeof useLightPlatformQuery_raw>;
export type LightPlatformLazyQuery_rawHookResult = ReturnType<typeof useLightPlatformLazyQuery_raw>;
export type LightPlatformSuspenseQuery_rawHookResult = ReturnType<typeof useLightPlatformSuspenseQuery_raw>;
export type LightPlatformQueryResult = Apollo.QueryResult<LightPlatformQuery, LightPlatformQueryVariables>;
export const PlatformCountsDocument = gql`
    query PlatformCounts($id: ID!) {
  Platform(id: $id) {
    ...FPlatformSesConfiguration
    ...FPlatformAllCounts
  }
}
    ${FPlatformSesConfigurationFragmentDoc}
${FPlatformAllCountsFragmentDoc}`;

/**
 * __usePlatformCountsQuery_raw__
 *
 * To run a query within a React component, call `usePlatformCountsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformCountsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformCountsQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlatformCountsQuery_raw(baseOptions: Apollo.QueryHookOptions<PlatformCountsQuery, PlatformCountsQueryVariables> & ({ variables: PlatformCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformCountsQuery, PlatformCountsQueryVariables>(PlatformCountsDocument, options);
      }
export function usePlatformCountsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformCountsQuery, PlatformCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformCountsQuery, PlatformCountsQueryVariables>(PlatformCountsDocument, options);
        }
// @ts-ignore
export function usePlatformCountsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformCountsQuery, PlatformCountsQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformCountsQuery, PlatformCountsQueryVariables>;
export function usePlatformCountsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformCountsQuery, PlatformCountsQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformCountsQuery | undefined, PlatformCountsQueryVariables>;
export function usePlatformCountsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformCountsQuery, PlatformCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformCountsQuery, PlatformCountsQueryVariables>(PlatformCountsDocument, options);
        }
export type PlatformCountsQuery_rawHookResult = ReturnType<typeof usePlatformCountsQuery_raw>;
export type PlatformCountsLazyQuery_rawHookResult = ReturnType<typeof usePlatformCountsLazyQuery_raw>;
export type PlatformCountsSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformCountsSuspenseQuery_raw>;
export type PlatformCountsQueryResult = Apollo.QueryResult<PlatformCountsQuery, PlatformCountsQueryVariables>;
export const PlatformDomainNameVerificationsDocument = gql`
    query PlatformDomainNameVerifications($platformId: ID!) {
  PlatformDomainNameVerifications(platformId: $platformId) {
    count
    nodes {
      ...FDomainNameVerification
    }
  }
}
    ${FDomainNameVerificationFragmentDoc}`;

/**
 * __usePlatformDomainNameVerificationsQuery_raw__
 *
 * To run a query within a React component, call `usePlatformDomainNameVerificationsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformDomainNameVerificationsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformDomainNameVerificationsQuery_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function usePlatformDomainNameVerificationsQuery_raw(baseOptions: Apollo.QueryHookOptions<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables> & ({ variables: PlatformDomainNameVerificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>(PlatformDomainNameVerificationsDocument, options);
      }
export function usePlatformDomainNameVerificationsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>(PlatformDomainNameVerificationsDocument, options);
        }
// @ts-ignore
export function usePlatformDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>;
export function usePlatformDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformDomainNameVerificationsQuery | undefined, PlatformDomainNameVerificationsQueryVariables>;
export function usePlatformDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>(PlatformDomainNameVerificationsDocument, options);
        }
export type PlatformDomainNameVerificationsQuery_rawHookResult = ReturnType<typeof usePlatformDomainNameVerificationsQuery_raw>;
export type PlatformDomainNameVerificationsLazyQuery_rawHookResult = ReturnType<typeof usePlatformDomainNameVerificationsLazyQuery_raw>;
export type PlatformDomainNameVerificationsSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformDomainNameVerificationsSuspenseQuery_raw>;
export type PlatformDomainNameVerificationsQueryResult = Apollo.QueryResult<PlatformDomainNameVerificationsQuery, PlatformDomainNameVerificationsQueryVariables>;
export const PlatformVerifiedEmailAddressesDocument = gql`
    query PlatformVerifiedEmailAddresses($platformId: ID!, $page: Int!) {
  PlatformVerifiedEmailAddresses(platformId: $platformId, page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FVerifiedEmailAddress
    }
  }
}
    ${FVerifiedEmailAddressFragmentDoc}`;

/**
 * __usePlatformVerifiedEmailAddressesQuery_raw__
 *
 * To run a query within a React component, call `usePlatformVerifiedEmailAddressesQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformVerifiedEmailAddressesQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformVerifiedEmailAddressesQuery_raw({
 *   variables: {
 *      platformId: // value for 'platformId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePlatformVerifiedEmailAddressesQuery_raw(baseOptions: Apollo.QueryHookOptions<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables> & ({ variables: PlatformVerifiedEmailAddressesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>(PlatformVerifiedEmailAddressesDocument, options);
      }
export function usePlatformVerifiedEmailAddressesLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>(PlatformVerifiedEmailAddressesDocument, options);
        }
// @ts-ignore
export function usePlatformVerifiedEmailAddressesSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>;
export function usePlatformVerifiedEmailAddressesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformVerifiedEmailAddressesQuery | undefined, PlatformVerifiedEmailAddressesQueryVariables>;
export function usePlatformVerifiedEmailAddressesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>(PlatformVerifiedEmailAddressesDocument, options);
        }
export type PlatformVerifiedEmailAddressesQuery_rawHookResult = ReturnType<typeof usePlatformVerifiedEmailAddressesQuery_raw>;
export type PlatformVerifiedEmailAddressesLazyQuery_rawHookResult = ReturnType<typeof usePlatformVerifiedEmailAddressesLazyQuery_raw>;
export type PlatformVerifiedEmailAddressesSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformVerifiedEmailAddressesSuspenseQuery_raw>;
export type PlatformVerifiedEmailAddressesQueryResult = Apollo.QueryResult<PlatformVerifiedEmailAddressesQuery, PlatformVerifiedEmailAddressesQueryVariables>;
export const PlatformsDocument = gql`
    query Platforms($page: Int!, $tier: String) {
  Platforms(page: $page, tier: $tier) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FPlatform
    }
  }
}
    ${FPlatformFragmentDoc}`;

/**
 * __usePlatformsQuery_raw__
 *
 * To run a query within a React component, call `usePlatformsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function usePlatformsQuery_raw(baseOptions: Apollo.QueryHookOptions<PlatformsQuery, PlatformsQueryVariables> & ({ variables: PlatformsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
      }
export function usePlatformsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
        }
// @ts-ignore
export function usePlatformsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformsQuery, PlatformsQueryVariables>;
export function usePlatformsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformsQuery | undefined, PlatformsQueryVariables>;
export function usePlatformsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
        }
export type PlatformsQuery_rawHookResult = ReturnType<typeof usePlatformsQuery_raw>;
export type PlatformsLazyQuery_rawHookResult = ReturnType<typeof usePlatformsLazyQuery_raw>;
export type PlatformsSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformsSuspenseQuery_raw>;
export type PlatformsQueryResult = Apollo.QueryResult<PlatformsQuery, PlatformsQueryVariables>;
export const SystemConfigurationDocument = gql`
    query SystemConfiguration {
  SystemConfiguration {
    availableSesIpPools
  }
}
    `;

/**
 * __useSystemConfigurationQuery_raw__
 *
 * To run a query within a React component, call `useSystemConfigurationQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useSystemConfigurationQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemConfigurationQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useSystemConfigurationQuery_raw(baseOptions?: Apollo.QueryHookOptions<SystemConfigurationQuery, SystemConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemConfigurationQuery, SystemConfigurationQueryVariables>(SystemConfigurationDocument, options);
      }
export function useSystemConfigurationLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<SystemConfigurationQuery, SystemConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemConfigurationQuery, SystemConfigurationQueryVariables>(SystemConfigurationDocument, options);
        }
// @ts-ignore
export function useSystemConfigurationSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<SystemConfigurationQuery, SystemConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<SystemConfigurationQuery, SystemConfigurationQueryVariables>;
export function useSystemConfigurationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemConfigurationQuery, SystemConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<SystemConfigurationQuery | undefined, SystemConfigurationQueryVariables>;
export function useSystemConfigurationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemConfigurationQuery, SystemConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemConfigurationQuery, SystemConfigurationQueryVariables>(SystemConfigurationDocument, options);
        }
export type SystemConfigurationQuery_rawHookResult = ReturnType<typeof useSystemConfigurationQuery_raw>;
export type SystemConfigurationLazyQuery_rawHookResult = ReturnType<typeof useSystemConfigurationLazyQuery_raw>;
export type SystemConfigurationSuspenseQuery_rawHookResult = ReturnType<typeof useSystemConfigurationSuspenseQuery_raw>;
export type SystemConfigurationQueryResult = Apollo.QueryResult<SystemConfigurationQuery, SystemConfigurationQueryVariables>;
export const UsersDocument = gql`
    query Users($page: Int!) {
  Users(page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FUser
    }
  }
}
    ${FUserFragmentDoc}`;

/**
 * __useUsersQuery_raw__
 *
 * To run a query within a React component, call `useUsersQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUsersQuery_raw(baseOptions: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables> & ({ variables: UsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
// @ts-ignore
export function useUsersSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQuery_rawHookResult = ReturnType<typeof useUsersQuery_raw>;
export type UsersLazyQuery_rawHookResult = ReturnType<typeof useUsersLazyQuery_raw>;
export type UsersSuspenseQuery_rawHookResult = ReturnType<typeof useUsersSuspenseQuery_raw>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
import useApiClient from '@dashboard/hooks/useAdministratorClient';

function bindClient<Options, Response>(useApolloHook: (options: Options) => Response) {
  return (options?: Options) => {
    const client = useApiClient();
    return useApolloHook({ client, ...options } as any);
  };
}

export const useRefreshDomainNameVerificationApprovalMutation = bindClient(useRefreshDomainNameVerificationApprovalMutation_raw);
export const useSendDomainNameVerificationApprovedEmailMessageMutation = bindClient(useSendDomainNameVerificationApprovedEmailMessageMutation_raw);
export const useSendDoubledDomainNameVerificationEmailMessageMutation = bindClient(useSendDoubledDomainNameVerificationEmailMessageMutation_raw);
export const useTriggerEmailMessageFailMutation = bindClient(useTriggerEmailMessageFailMutation_raw);
export const useTriggerEmailMessageSendMutation = bindClient(useTriggerEmailMessageSendMutation_raw);
export const useTriggerWorkflowEventFailMutation = bindClient(useTriggerWorkflowEventFailMutation_raw);
export const useTriggerWorkflowEventProcessMutation = bindClient(useTriggerWorkflowEventProcessMutation_raw);
export const useUpdateDomainNameVerificationApprovalMutation = bindClient(useUpdateDomainNameVerificationApprovalMutation_raw);
export const useUpdateDomainNameVerificationMailFromMutation = bindClient(useUpdateDomainNameVerificationMailFromMutation_raw);
export const useUpdatePlatformMutation = bindClient(useUpdatePlatformMutation_raw);
export const useDomainNameVerificationQuery = bindClient(useDomainNameVerificationQuery_raw);
export const useDomainNameVerificationsQuery = bindClient(useDomainNameVerificationsQuery_raw);
export const useEmailMessagesQuery = bindClient(useEmailMessagesQuery_raw);
export const usePlatformQuery = bindClient(usePlatformQuery_raw);
export const useLightPlatformQuery = bindClient(useLightPlatformQuery_raw);
export const usePlatformCountsQuery = bindClient(usePlatformCountsQuery_raw);
export const usePlatformDomainNameVerificationsQuery = bindClient(usePlatformDomainNameVerificationsQuery_raw);
export const usePlatformVerifiedEmailAddressesQuery = bindClient(usePlatformVerifiedEmailAddressesQuery_raw);
export const usePlatformsQuery = bindClient(usePlatformsQuery_raw);
export const useSystemConfigurationQuery = bindClient(useSystemConfigurationQuery_raw);
export const useUsersQuery = bindClient(useUsersQuery_raw);
